import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-staging-from-backup-modal',
  templateUrl: './staging-from-backup-modal.component.html',
  styleUrls: ['./staging-from-backup-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StagingFromBackupModalComponent {
  constructor(
    public dialogRef: MatDialogRef<StagingFromBackupModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
}
